import { Outlet } from 'react-router-dom'
import { Header } from '../components/common/Header';
import { Footer } from '../components/common/Footer';

export const Layout = () => {

    return (
        <>
            <div>
                <Header />
                <div className='main-contain'>
                    <Outlet />
                </div>
                <Footer />
            </div>
        </>
    )
}
